<template>
  <span
    class="mark"
    :class="kind"
    :title="label"
    :role="decorative ? undefined : 'img'"
    :aria-label="decorative ? undefined : label"
    :aria-hidden="decorative ? 'true' : undefined"
  >
    <svg v-if="kind === 'time' || kind === 'show'" viewBox="0 0 16 16" width="16" height="16">
      <circle cx="8" cy="8" r="5.25" fill="none" stroke="currentColor" stroke-width="1.5" />
      <path
        d="M8 4.7V8l2.2 1.4"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg v-else-if="kind === 'play'" viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5.2 1.8h5.6v2.1a2.8 2.8 0 0 1-5.6 0V1.8z" />
      <path d="M5.2 3.1H3.3A2.2 2.2 0 0 0 5.4 6.2" />
      <path d="M10.8 3.1h1.9A2.2 2.2 0 0 1 10.6 6.2" />
      <path d="M8 7.1v2.1" />
      <path d="M6.1 9.2h3.8v1.15H6.1z" />
      <path d="M5.4 12.2h5.2" />
    </svg>
    <svg v-else viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M6.5 2.8H3.4v10.4h3.1" />
      <path d="M7 8h5.6" />
      <path d="M10.4 5.4 13 8l-2.6 2.6" />
    </svg>
  </span>
</template>

<script setup lang="ts">
defineProps<{
  kind: 'play' | 'time' | 'bye' | 'show'
  label?: string
  decorative?: boolean
}>()
</script>

<style scoped>
.mark {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

/* Red marks who missed the room. Green marks a win. Same colors in light and dark. */
.mark.time,
.mark.bye {
  color: light-dark(#c5221f, #ff6b6b);
}

.mark.play,
.mark.show {
  color: light-dark(#137333, #5cdb7a);
}
</style>
